import { projectService } from '@/services/project/project-service';
import { projectKeys } from '@/utils/queryKeys';
import { useMutation, useQueryClient } from '@tanstack/vue-query';
import { computed, toValue, type MaybeRefOrGetter } from 'vue';

export const useProjectNotesDataMutation = (
  projectId: MaybeRefOrGetter<string>,
) => {
  const id = computed(() => toValue(projectId));
  const queryClient = useQueryClient();
  return useMutation({
    mutationKey: ['app', 'projects', id, 'notes'],
    mutationFn: async (updatedNotes: string) => {
      // Simulate an API call to update the project notes
      await projectService.updateProjectNotes(id.value, updatedNotes);
    },
    onSuccess: async () => {
      await queryClient.invalidateQueries({
        queryKey: projectKeys.notes({ projectId: id.value }),
      });
    },
  });
};
